import Image from 'next/image'
import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-white">
      <div
        className="bg-white grid grid-flow-col-dense gap-2 py-4 px-4 md:px-6 mx-auto border-b ult-mobile-footer"
        style={{ maxWidth: '1200px' }}
      >
        <div className="flex flex-row items-center w-full row-span-3">
          <Image
            className="w-[150px] md:w-[200px]"
            src="/images/logo-kemendikdasmen-ult.png"
            width={200}
            height={67}
            alt="Logo Kemendikdasmen"
          />
        </div>
        <div className="flex flex-row items-center w-full row-span-3 justify-end">
          <Image
            className="w-[88px] sm:w-[120px] md:w-[150px]"
            src="/images/ult/img-pendidikan-bermutu.png"
            width={150}
            height={50}
            alt="Pendidikan Bermutu"
          />
          <Image
            className="w-[80px] sm:w-[120px] md:w-[150px] mt-2 ml-2 mr-1 md:ml-6"
            src="/images/ult/img-kemendikdasmen-ramah.png"
            width={150}
            height={50}
            alt="Kemendikdasmen Ramah"
          />
        </div>
      </div>
      <div
        className="grid grid-cols-1 md:grid-cols-[2fr_2fr_1fr] w-full py-4 px-6 mt-2 mx-auto gap-4 the-three-section"
        style={{ maxWidth: '1200px' }}
      >
        <div className="mb-4 div-1 alamat-section">
          <h4 className="mb-4 text-[17px] text-charcoal font-semibold">
            Alamat
          </h4>
          <div className="flex items-center w-full">
            <div className="flex justify-between items-start mb-3">
              <div className="w-[30px] mr-2 flex-shrink-0">
                <Image
                  src="/favicon/ico-house.png"
                  width={30}
                  height={30}
                  alt="Alamat"
                />
              </div>
              <div className="flex-1">
                <p className="mb-1 text-charcoal font-semibold text-sm leading-4">
                  Gedung C, Lantai Dasar, Unit Layanan Terpadu Biro Komunikasi
                  dan Hubungan Masyarakat Kemendikdasmen
                </p>
                <p className="text-sm">
                  Jl. Sudirman, Senayan - Jakarta, 10270
                </p>
                <a
                  href="https://maps.app.goo.gl/eRXS83xEAgTjBYj27"
                  target="_blank"
                >
                  <p
                    className="text-sm"
                    style={{ textDecoration: 'underline', color: '#0746BD' }}
                  >
                    Lihat di Peta
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="flex items-center bg-white w-full">
            <div className="flex justify-between items-start">
              <div className="w-[30px] mr-2 flex-shrink-0">
                <Image
                  src="/favicon/ico-clock.png"
                  width={22}
                  height={22}
                  alt="Jam Layanan"
                />
              </div>
              <div className="flex-1">
                <p className="text-sm">Layanan Tatap Muka: 08.00 - 15.00</p>
                <p className="text-sm">Layanan Contact Center: 08.00 - 17:00</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4 div-2 hubungi-kami-section">
          <h4 className="mb-4 text-[17px] text-charcoal font-semibold">
            Hubungi Kami
          </h4>
          <div className="flex items-center w-full">
            <div className="flex justify-between items-start mb-3">
              <div className="w-[30px] mr-2 flex-shrink-0">
                <Image
                  src="/favicon/ico-tel.png"
                  width={26}
                  height={26}
                  alt="Telepon"
                />
              </div>
              <div className="flex-1">
                <a href="tel:177">
                  <p className="text-sm">177</p>
                </a>
              </div>
            </div>
          </div>
          <div className="flex items-center bg-white w-full">
            <div className="flex justify-between items-start mb-3">
              <div className="w-[30px] mr-2 flex-shrink-0">
                <Image
                  src="/favicon/ico-email.png"
                  width={26}
                  height={26}
                  alt="Email"
                />
              </div>
              <div className="flex-1">
                <a href="mailto:pengaduan@kemendikdasmen.go.id">
                  <p className="text-sm">pengaduan@kemendikdasmen.go.id</p>
                </a>
              </div>
            </div>
          </div>
          <div className="flex items-center bg-white w-full">
            <div className="flex justify-between items-start mb-3">
              <div className="w-[30px] mr-2 flex-shrink-0">
                <Image
                  src="/favicon/ico-instagram.png"
                  width={22}
                  height={22}
                  alt="Instagram"
                  style={{ marginLeft: '2px' }}
                />
              </div>
              <div className="flex-1">
                <a href="https://www.instagram.com/ult.kemendikdasmen">
                  <p className="text-sm">@ult.kemendikdasmen</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4 flex justify-start md:justify-end items-end div-2 icons-set-section">
          <Image
            src="/images/ult/logo-integritas.png"
            width={64}
            height={64}
            className="mr-2 mb-2"
            alt="Logo Integritas"
          />
          <Image
            src="/images/ult/logo-anti-korupsi.png"
            width={64}
            height={64}
            className="mr-2 mb-2"
            alt="Logo Anti Korupsi"
          />
          <Image
            src="/images/ult/logo-tolak-gratifikasi.png"
            width={64}
            height={64}
            className="mr-2 mb-2"
            alt="Logo Tolak Gratifikasi"
          />
        </div>
      </div>
      <div className="text-center bg-gray-800 w-full p-4 ult-footer-black">
        <p className="text-sm" style={{ color: 'white' }}>
          ©2025, Kementerian Pendidikan Dasar dan Menengah. Hak Cipta
          Dilindungi.
        </p>
      </div>
    </footer>
  )
}

export default Footer
